// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6asp7","newExpiryDate":"styles_newExpiryDate__3A8fH","footer":"styles_footer__2vZ8k"};